import { render, staticRenderFns } from "./ArrowRightIcon.vue?vue&type=template&id=13dab6f3&scoped=true&"
import script from "./ArrowRightIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowRightIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArrowRightIcon.vue?vue&type=style&index=0&id=13dab6f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dab6f3",
  null
  
)

export default component.exports